import pl_default, { standalone as pl_default_standalone } from '@/localization/default';
import pl_custom, { standalone as pl_custom_standalone } from '@/localization/custom';

const appInitialState = {
	isLoading: false,
	appError: 0,
	isNotFound: false,
	cookiePermission: false,
	dict: {},
	dictStandalone: {},
	modalInfo: "",
	lastLettersURL: null,
	config: {
		reactAppApi: null,
	},
	letterTemplatesSettings: null,
	isMimAuthAvailable: false,
	mode: null,
	usersLimit: null,
	langNormalization: true,
	ppj: null,
	dictionaryExport: false,
};

const merge = (def, custom) => {
	if (def == null) return custom;
	if (custom == null) return def;
	if (Array.isArray(custom) || typeof custom !== 'object') {
		return custom;
	}
	const merged = { ...def };
	for (const [ key, value ] of Object.entries(custom)) {
		merged[key] = merge(merged[key], value);
	}
	return merged;
};

// let dct = { ...{}, pl };
let initState = {
	...appInitialState,
	dict: merge(pl_default, pl_custom),
	dictStandalone: merge(pl_default_standalone, pl_custom_standalone),
};

export function app(state = initState, action) {
	switch (action.type) {
		case 'SAVE_COOKIE':
			return {
				...state,
				// currentLang: action.payload.currentLang,
				cookiePermission: action.payload.cookiePermission,
				// dict: dct[action.payload.currentLang],
			};
		// case 'SET_CURRENT_LANGUAGE':
		// 	return {
		// 		...state,
		// 		langs: state.langs.map(lang => { return { ...lang, active: lang.id === action.lang.id }; }),
		// 		currentLang: action.lang.id,
		// 		dict: dct[action.lang.id],
		// 	};
		// case 'SET_APP_ERROR':
		// 	return {
		// 		...state,
		// 		isAppError: true,
		// 	};
		// case 'RESET_APP_ERROR':
		// 	return {
		// 		...state,
		// 		isAppError: false,
		// 	};
		case 'SET_CONFIG':
			return {
				...state,
				config: action.config,
			};
		case 'SET_LETTER_TEMPLATES_SETTINGS': 
			return {
				...state,
				letterTemplatesSettings: action.letterTemplatesSettings,
			};
		case 'SET_LOADING':
			return {
				...state,
				isLoading: action.isLoading,
			};
		case 'SET_ERROR':
			return {
				...state,
				appError: action.errCode,
			};
		case 'SET_NOTFOUND':
			return {
				...state,
				isNotFound: action.isNotFound,
			};
		case 'SET_COOKIE_PERMISSION':
			return {
				...state,
				cookiePermission: true,
			};

		case 'SET_MODAL_INFO':
			return {
				...state, 
				modalInfo: action.info,
			};
		case 'SET_LAST_LETTERS_URL':
			return {
				...state, 
				lastLettersURL: action.url,
			};
		case 'SET_INSTANCE_CONFIGURATION':
			return {
				...state,
				mode: action.config.application.mode,
				usersLimit: action.config.usersLimit,
				langNormalization: action.config.langNormalization.enabled,
				ppj: action.config.questions,
				isMimAuthAvailable: action.config.auth.mim.enabled,
				dict: action.config.application.mode === 'standalone' ? merge(state.dict, state.dictStandalone) : state.dict,
				dictionaryExport: action.config.dictionary.export.enabled,
			};

		default:
			return state;
	}
}